import React, { useState } from "react";
import { Button, Input, Form } from "antd";
import Typography from "app/shared/Typography";
import "./AirCredFollowupUpdate.scss";
import Logo from "static/images/FinLogo.png";
import SuccessMessage from 'static/images/Success message vector.png';
import Logo2 from "static/images/Logo2.png";
import { apiPost } from "app/services/apiServices";

export default function AirCredFollowupUpdate(props: any) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setLoading(true);
    form.validateFields()
      .then(values => {
        setTimeout(() => {
          setLoading(false);
          setSubmitted(true);
        }, 1000);
      })
      .catch(err => {
        setLoading(false);
      });
  };

  // Render form view
  const renderFormView = () => (
     
    <div className="FormContainer">
      <div className="header">
        <Typography variant="h6">Update Airline Credentials</Typography>
      </div>
      
      <div className="info-section">
        <div className="info-item">
          <span className="label">Client</span>
          <span className="value">Client ABC</span>
        </div>
        <div className="info-item">
          <span className="label">Airline</span>
          <span className="value">Lufthansa Airline</span>
        </div>
        <div className="info-item">
          <span className="label">PAN</span>
          <span className="value">KLEPS1189L</span>
        </div>
      </div>

      <Form form={form} layout="vertical" className="credentials-form">
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input placeholder="Enter username" />
        </Form.Item>

        <Form.Item
          label="Password"  
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input placeholder="Enter password" />
        </Form.Item>

        <Form.Item
          label="Code"
          name="code"
          rules={[{ required: true, message: 'Please input code!' }]}
        >
          <Input placeholder="Enter code" />
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            onClick={handleSubmit} 
            loading={loading}
            className="submit-button"
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  
  );


  const renderSuccessView = () => (
    <div className="success-container">
      {/* <div className="logo-header">
        <div className="logo">
      <img src={Logo2} alt="FInkraft Logo" style={{width:'170px', height:'40px'}}/>
        </div>
      </div> */}
      
      <div className="success-content">
        <div className="success-image">
         <img src={SuccessMessage} alt="Successfully completed" style={{width:'400px', height:'400px'}}/>
        </div>
        
        <Typography variant="h5" style={{ color: '#4a919e', marginBottom: '16px', fontWeight: 600 }}>
          Form Submission Successful!
        </Typography>
        
        <Typography variant="body" style={{ textAlign: 'center', color: '#666', maxWidth: '600px' }}>
          Thank you for taking the time to complete the form. Your submission has been 
          received successfully, and our team will review it shortly.
        </Typography>
      </div>
    </div>
  );

  return (
    <div className="AirCredFollowupUpdate">
   <div className="logoContainer">
        
        <img src={Logo} alt="Finkraft Logo" style={{width:'124px', height:'40px'}}/>
        </div>
      {submitted ? renderSuccessView() : renderFormView()}
    </div>
  );
}